import { Store } from 'src/store/index';

const getCurrencyId = (store: Store) => store.price.currencyId;

export default getCurrencyId;
